import React, { useEffect } from "react";
import { getUrlParams } from "../apiService/timespam";
import DoctorHomeCard from "../Components/DoctorHomeCard";
import ProfileHomeCardAdhd from "../Components/ProfileHomeCardAdhd";
import "./Theme.css";
import "./HomePageAdhd.css";

const HomePageAdhd = () => {
  const { theme, lang } = getUrlParams();

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  return (
    <section className="adhd-home-page">
      <DoctorHomeCard />
      <ProfileHomeCardAdhd />
    </section>
  );
};

export default HomePageAdhd;
